<div class="impersonation-banner" *ngIf="isImpersonating">
  <div class="d-flex align-items-center justify-content-center gap-3">
    <i class="bi bi-eye-fill"></i>
    <span>You are viewing as <strong>Agency Admin</strong> for <strong>{{agencyName}}</strong></span>
    <button class="btn btn-sm btn-light" (click)="exitImpersonation()">
      <i class="bi bi-box-arrow-left me-1"></i>Exit
    </button>
  </div>
</div>
